import React, { useEffect, useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  EnvironmentOutlined,
  TeamOutlined,
  BankOutlined,
  SearchOutlined,
  CalendarOutlined,
  ClockCircleOutlined,
  ArrowRightOutlined,
  CheckCircleFilled,
  GlobalOutlined,
  ShoppingOutlined,
} from "@ant-design/icons";

import "./jobListingWhoIsHiringNowCompanyPage.scss";
import JobListingsPageHeader from "../jobListingPageHeader";
import useNuJobsStore from "../../../store/nujobs.store";
import { SUPPORTED_LOCATION } from "../../../helper/categoryconstants";
import { Select } from "antd";

function NuJobsWhoisHiringCompanyPage() {
  const navigate = useNavigate();
  const { qhoid } = useParams();

  const [keyword, setKeyword] = useState("");
  const [location, setLocation] = useState([]);
  const { getOSAllJds,openJds,totalOpenJds } = useNuJobsStore();

  const { hiringCompanies } = useNuJobsStore();
  const { upcomingEvents,nuJobsUpcomingEvents,nuJobsGetJDandEvent } = useNuJobsStore();  
  useEffect(() => {
      // Fetch hiring companies from the store or API
      // This is just a placeholder; replace with actual data fetching logic
      // setHiringCompanies(fetchedCompanies);
      nuJobsUpcomingEvents(0)
    }, []);  
  // ------------------------------------------------------------
  // MOCK COMPANY DATA
  // Replace with backend response later
  // ------------------------------------------------------------

  const company = {
    id: qhoid,
    name: "HMW Communications",
    logo: "",
    verified: true,

    industry: "Information Technology & Services",
    headquarters: "Bangalore, Karnataka",
    companySize: "20–50 employees",
    website: "https://www.hmwcomm.com",

    about:
      "HMW Communications is a technology-focused staff agumentation and software services based organization delivering software engineering, AI, cloud, digital transformation and enterprise solutions. The company works with customers across multiple industries and provides opportunities across engineering, product and technology functions.",

    openJobs: totalOpenJds,
  };


  // ------------------------------------------------------------
  // MOCK EVENTS
  // ------------------------------------------------------------

  const events = [
    {
      id: "EVENT-101",
      title: "Walk-in Drive — Java Developers",
      date: "12 Oct 2026",
      time: "10:00 AM – 4:00 PM",
      location: "Bangalore",
      type: "Walk-in",
    },
    {
      id: "EVENT-102",
      title: "Frontend Developer Hiring Drive",
      date: "18 Oct 2026",
      time: "11:00 AM – 3:00 PM",
      location: "Online",
      type: "Virtual",
    },
  ];

  // ------------------------------------------------------------
  // SEARCH
  // -----------------------------------------------------------/
  const [noJobsFoundString, setNoJobsFoundString] = useState("");

  const handleResults = (num) =>{
    if(num >0){
       navigate('/jobListingSearchResultsPage')
       setNoJobsFoundString("")
    }else{
      navigate('/jobListingSearchResultsPage')
      setNoJobsFoundString("No Jobs Found")
    }
  } 
  const handleSearch = () => {
    const jasonValues = encodeJson()
    getOSAllJds(jasonValues,handleResults)    
  };
 
  const handleViewJob = (job) => {
    var source = "opensearch"
    navigate(`/nujobsViewJobsContainerOpenSearch/${source}/${job.QhCompanyJID}/${qhoid }`);
  };

  const handleNavigate = (qhoid, qhjid) => {
    //because while doing viewevent, needs to have jd from backend
    var source = "viewevent"
    navigate(`/nujobsViewJobsContainerOpenSearch/${source}/${qhjid}/${qhoid }`);
  };

  const handleViewEvent = (event) => {
    nuJobsGetJDandEvent(event.qhoid,event.qhcompanyjid,handleNavigate );
  };


  const getCompanyName = (qhoid) => {
    const companyDetails = hiringCompanies.find(
      (company) => company.id === qhoid
    );
    return companyDetails?.name || null;
  } 
  const encodeJson = () =>{
        let encodedJsonValues ={};
        encodedJsonValues.keywords= keyword;
        encodedJsonValues.city=location;
        encodedJsonValues.category=null;  
        encodedJsonValues.timestamp= 0;  
        encodedJsonValues.postingdate= "All"
        encodedJsonValues.pagenum= 1;
        encodedJsonValues.maxPerPage= 10;
        encodedJsonValues.qhoid=qhoid;
        encodedJsonValues.companyname=getCompanyName(qhoid);

        //from values
        encodedJsonValues.minexp=null;
        encodedJsonValues.maxexp=null;  
        encodedJsonValues.minctc= null;  
        encodedJsonValues.maxctc= null
        encodedJsonValues.noticeperiod= []; 
        encodedJsonValues.postingdate=[];
        encodedJsonValues.workmode=null;  
        encodedJsonValues.diversity= null;  
        encodedJsonValues.role= []
        encodedJsonValues.roletype= []
        encodedJsonValues.companytype= null
        encodedJsonValues.jobfor= null                               
        return encodedJsonValues
    }

    

  useEffect(() => {
        const jasonValues = encodeJson()
        getOSAllJds(jasonValues,null)
  } , []);

 
  return (
    <div className="nujobs-company-page">
      <JobListingsPageHeader/>
      {/* ===================================================== */}
      {/* COMPANY HERO */}
      {/* ===================================================== */}

      <section className="company-hero">
        <div className="company-hero-inner">

          <div className="company-logo">
            {company.logo ? (
              <img src={company.logo} alt={company.name} />
            ) : (
              <BankOutlined />
            )}
          </div>

          <div className="company-main-info">

            <div className="company-title-row">
              <h1>{openJds?.[0]?.CompanyName}</h1>
              {company.verified && (
                <span className="verified-company">
                  <CheckCircleFilled />
                  Verified
                </span>
              )}
            </div>

            <div className="company-meta">
              <span>
                <BankOutlined />
                {company.industry}
              </span>

              <span>
                <EnvironmentOutlined />
                {company.headquarters}
              </span>

              <span>
                <TeamOutlined />
                {company.companySize}
              </span>
            </div>

          </div>

          <div className="company-open-jobs">
            <strong>{company.openJobs}</strong>
            <span>Open Positions</span>
          </div>

        </div>
      </section>


      <main className="company-page-content">

        {/* ===================================================== */}
        {/* ABOUT COMPANY */}
        {/* ===================================================== */}

        <section className="company-section company-about-section">

          <div className="section-heading">
            <div>
              <h2>About Company</h2>
              <p>Learn more about the company and its workplace.</p>
            </div>
          </div>

          <div className="about-card">

            <p className="company-description">
              {company.about}
            </p>

            <div className="company-info-grid">

              <div className="company-info-item">
                <div className="company-info-icon">
                  <TeamOutlined />
                </div>

                <div>
                  <span>Company Size</span>
                  <strong>{company.companySize}</strong>
                </div>
              </div>


              <div className="company-info-item">
                <div className="company-info-icon">
                  <EnvironmentOutlined />
                </div>

                <div>
                  <span>Headquarters</span>
                  <strong>{company.headquarters}</strong>
                </div>
              </div>


              <div className="company-info-item">
                <div className="company-info-icon">
                  <BankOutlined />
                </div>

                <div>
                  <span>Industry</span>
                  <strong>{company.industry}</strong>
                </div>
              </div>


              <div className="company-info-item">
                <div className="company-info-icon">
                  <GlobalOutlined />
                </div>

                <div>
                  <span>Website</span>

                  <a
                    href={company.website}
                    target="_blank"
                    rel="noreferrer"
                  >
                    Visit Website
                  </a>
                </div>
              </div>

            </div>

          </div>

        </section>


        {/* ===================================================== */}
        {/* SEARCH JOBS */}
        {/* ===================================================== */}

        <section className="company-section company-job-search-section">

          <div className="section-heading">
            <div>
              <h2>Find {openJds?.[0]?.CompanyName} Jobs</h2>
              <p>
                Search current opportunities by skill, role or location.
              </p>
            </div>
          </div>


          <div className="company-job-search">

            <div className="search-input-wrapper">
              <SearchOutlined />

              <input
                type="text"
                placeholder="Job title, skill or keyword"
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
              />
            </div>


            <div className="search-input-wrapper location-wrapper">
              <EnvironmentOutlined className="search-field-icon" />

              <Select
                mode="multiple"
                className="company-location-select"
                maxTagCount="responsive"
                size="large"
                placeholder="Location"
                allowClear
                showSearch
                value={location}
                onChange={(values) => setLocation(values)}
                options={SUPPORTED_LOCATION}
                optionFilterProp="label"
                style={{ width: "100%" }}
              />
            </div>


            <button
              className="company-search-btn"
              onClick={handleSearch}
            >
              <SearchOutlined />
              Search Jobs
            </button>

          </div>

        </section>


        {/* ===================================================== */}
        {/* TOP OPENINGS */}
        {/* ===================================================== */}

        <section className="company-section">

          <div className="section-heading section-heading-with-action">

            <div>
              <h2>Top Openings</h2>
              <p>
                Explore some of the latest opportunities at {company.name}.
              </p>
            </div>
          </div>


          <div
            key={openJds?.length ? "jobs-found" : "no-jobs"}
            className="company-job-results"
          >
            {Array.isArray(openJds) && openJds.length > 0 ? (
              <div className="company-jobs-grid">
                {openJds.slice(0, 6).map((job) => (
                  <div
                    className="company-job-card"
                    key={`${job.QhOID}-${job.QhCompanyJID}`}
                  >
                            <div className="job-card-top">

                              <div className="job-company-icon">
                                <ShoppingOutlined />
                              </div>

                              <span className="job-posted">
                                {job.JDOther.PostingDate}
                              </span>

                            </div>


                            <h3>{job.JDDetails.Title}</h3>
                            <div className="job-meta">

                              <span>
                                <EnvironmentOutlined />
                                {job.JDRequired.WorkLocation}
                              </span>

                              <span>
                                <ShoppingOutlined />
                                {`${job.JDRequired.MinExperience}–${job.JDRequired.MaxExperience} Years`}
                              </span>

                            </div>


                            <div className="job-work-mode">
                              {job.JDRequired.WorkMode}
                            </div>


                            <div className="job-skills">

                              {job?.JDRequired.kwarray?.slice(0, 3)?.map((skill) => (
                                <span key={skill}>
                                  {skill}
                                </span>
                              ))}

                            </div>


                            <div className="job-card-footer">

                              <button
                                onClick={() => handleViewJob(job)}
                              >
                                View Job
                                <ArrowRightOutlined />
                              </button>

                            </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className="no-company-jobs">
                <SearchOutlined />
                <h3>No matching jobs found</h3>
                <p>Try changing your keyword or location.</p>
              </div>
            )}
          </div>
        </section>


        {/* ===================================================== */}
        {/* EVENTS */}
        {/* ===================================================== */}

        {upcomingEvents?.length > 0 && (

          <section className="company-section company-events-section">

            <div className="section-heading section-heading-with-action">

              <div>
                <h2>Upcoming Hiring Events</h2>

                <p>
                  Meet the hiring team and explore upcoming opportunities.
                </p>
              </div>

            </div>


            <div className="company-events-grid">

              {upcomingEvents?.map((event) => (

                <div
                  className="company-event-card"
                  key={event.qhoid}
                >

                  <div className="event-date-box">

                    <CalendarOutlined />

                    <span>{event.startdate}</span>

                  </div>


                  <div className="event-content">

                    <span className="event-type">
                      {event.eventtype}
                    </span>

                    <h3>{event.eventname}</h3>


                    <div className="event-meta">

                      <span>
                        <ClockCircleOutlined />
                        {event.starttime}- {event.endtime}
                      </span>

                      <span>
                        <EnvironmentOutlined />
                        {event.city}
                      </span>

                    </div>

                  </div>


                  <button
                    className="event-view-btn"
                    onClick={() => handleViewEvent(event)}
                  >
                    View Event
                    <ArrowRightOutlined />
                  </button>

                </div>

              ))}

            </div>

          </section>

        )}

      </main>

    </div>
  );
}

export default NuJobsWhoisHiringCompanyPage;
